import { render, staticRenderFns } from "./BrowseMerchantBox.vue?vue&type=template&id=6d1a159f&scoped=true"
import script from "./BrowseMerchantBox.vue?vue&type=script&lang=js"
export * from "./BrowseMerchantBox.vue?vue&type=script&lang=js"
import style0 from "./BrowseMerchantBox.vue?vue&type=style&index=0&id=6d1a159f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1a159f",
  null
  
)

export default component.exports